import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject } from '@angular/core';
import { RouterExtService } from '../../../services/previous-route.service';
import { HomepageService } from '../../../services/homepage.service';
import { SearchService } from '../../../services/search.service';
import { CookieService } from 'ngx-cookie-service';
import { NgForm } from '@angular/forms'; 
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-review-search',
  templateUrl: './review-search.component.html',
  styleUrls: ['./review-search.component.css']
})
export class ReviewSearchComponent implements OnInit {		
  private readonly notifier: NotifierService;
  	constructor(@Inject(DOCUMENT) private document: Document, private route: ActivatedRoute, private routerService: RouterExtService, private searchService: SearchService, private homepageService: HomepageService, private cookieService: CookieService, notifierService: NotifierService) {
    this.notifier = notifierService;
   }
  	reviewCategories: any = [];
  	previousUrl:string = '';
  	previousUrlTxt:string = '';	
    responseAPIstatus: boolean = false;
  	saveReviewStatus: boolean = false;
    searchStatus: boolean = false;
    totalLocations: number = 0;
    curentLoc:any = [];
    reviewStarts: number = 0;
    searchResults : any = [];
    resourcesDetail : any = [];
    listView: string = 'true';
    patronPermissions : any = null;
    selectedResourcesIds: any = [];
    selectedCategories: any = [];
    isLogin: boolean =false;
    isEditAndPublishReview: boolean =false;
    isAdmin: boolean =false;
    patronNumber: string = null; //Changes type number --> string
    editedReviewId:any = '';
    reviewerNameReadOnly : boolean = true;
    reviewSearchForm : boolean = true;
    initialRate: number = 0;
    exploreId: any;
  	ngOnInit() {
  		this.document.body.classList.add('inner-page');
    	this.document.body.classList.add('list');
    	this.previousUrl = this.routerService.getPreviousUrl();  
    	this.previousUrlTxt = this.routerService.getTextUrl(); 
    	this.routerService.setTextUrl('Reviews Search');    	
    	this.homepageService.getReviewCategories().subscribe((data)=>{
	      	this.reviewCategories = data;
    	});
      if(this.cookieService.check( 'Popular_title_List_View' ) ){
        this.listView = this.cookieService.get( 'Popular_title_List_View' );
      }

      if(this.cookieService.check( 'patronPermissions' ) ){
        var permissions = JSON.parse(this.cookieService.get( 'patronPermissions' ));        
        var details = JSON.parse(this.cookieService.get( 'userDetail' ));        
        this.isEditAndPublishReview = permissions.opacEditAndPublishReview;        
        this.isAdmin = permissions.opacAdmin;        
        this.patronNumber = details.patronNumber;
      }

      this.homepageService.getConfig().subscribe((data) => {
        var tenant = data.data.tenantCode.toLowerCase();
        var selectedId =  this.cookieService.get('selectedlocation'+tenant)
        this.totalLocations = data.data.settings.location.locations.length;
        data.data.settings.location.locations.forEach( (loc) => {
          if(loc.id == selectedId){
            this.curentLoc['id'] = loc.id;
            this.curentLoc['name'] = loc.name;
          }
        });
      });

      if( localStorage.getItem('selectedResourcesIds') != null ){
        this.selectedResourcesIds = JSON.parse(localStorage.getItem('selectedResourcesIds'));     
      }  
      this.loadParamResource();
    }

    isReviewerPatronNumberMatch(patronNumber: any, reviewerPatronNumber: any[]): boolean {
      return (patronNumber == reviewerPatronNumber);
    }

    loadParamResource(){
      this.route.queryParams.subscribe(params => {
        const reviewstatus = true;
        const starrating = params['minrate'];
        const reviewer = params['reviewername'];
        const categories: string = params['categories'];
        this.exploreId = params['exp-btn-id'];
        
        if (params['minrate']) {
          this.responseAPIstatus = false;
          this.searchStatus = true;
          this.reviewSearchForm = false;
          var review_age = params['reviewage'];
          if(review_age == ''){
            review_age = '*';
          }
          var reviewCategories: any = [];
          if(categories != ''){
            reviewCategories = categories.split(',');
          }
          const location = this.curentLoc['id']
          this.searchService.getReviewSearch(reviewstatus,starrating, review_age, location, reviewer, reviewCategories, this.exploreId).subscribe((data : any) => {
            this.responseAPIstatus = true;
            this.searchResults = data;
               this.searchStatus = false;
            var self = this;
            setTimeout(function(){
              if(self.editedReviewId != '' && typeof(self.editedReviewId) != 'undefined'){
                var topOffset = $('a[href="/review/'+self.editedReviewId+'"]').offset().top;
                self.editedReviewId = '';
              } else {
                var topOffset = $('.viewContainer').offset().top;
              }
              $('html, body').stop().animate({
                scrollTop: topOffset
              }, 1000);        
            },100);
          });
        } else {
          this.reviewSearchForm = true;
        }
      });
    }

    onRatingChange(event){
      $('#reviewStar').val(event.rating);
      this.initialRate = event.rating
      $(document).find('.messageReview.error').remove();
    }
 	
    onRatingChangeEdit(event){      
      $('#reviewStarEdit').val(event.rating);
    }

  searchReview(form : NgForm){
    this.responseAPIstatus = false;
    this.searchStatus = true;
    let formValues : any = form.value;
    if(typeof(formValues.reviewstatus) != 'undefined'){
      var reviewstatus:any = formValues.reviewstatus;
      if(reviewstatus == 'true'){
        reviewstatus = true;
      } else if(reviewstatus == 'false'){
         reviewstatus = false; 
      } else {
        reviewstatus = null; 
      }
    } else {
      var reviewstatus:any = true;
    }
    // var starrating = parseInt($('#reviewStar').val().toString());
    var starrating = this.initialRate;
    var review_age = formValues.review_age;
    if(review_age == ''){
      review_age = '*';
    }
    var location = formValues.location;
    var reviewer = formValues.reviewer;

    var reviewCategories = [];
    $('input[name="categories_for_review"]:checked').each(function(){
      reviewCategories.push($(this).val());
    });

    this.searchService.getReviewSearch(reviewstatus,starrating, review_age, location, reviewer, reviewCategories, this.exploreId).subscribe((data : any) => {
      this.responseAPIstatus = true;
      this.searchResults = data;
         this.searchStatus = false;
      var self = this;
      setTimeout(function(){
        if(self.editedReviewId != '' && typeof(self.editedReviewId) != 'undefined'){
          var topOffset = $('a[href="/review/'+self.editedReviewId+'"]').offset().top;
          self.editedReviewId = '';
        } else {
          var topOffset = $('.viewContainer').offset().top;
        }
        $('html, body').stop().animate({
          scrollTop: topOffset
        }, 1000);        
      },100);
    });
  }


    lazyLoading(cache, currentOffset, listSize){
   /*    var offset = (currentOffset + listSize);
      if(this.lazyRequeat == true || this.infiniteScroll === false || this.totalRecords < offset){
        return false;
      }
      this.lazyRequeat = true;
      if(this.maxRecords > offset){

        return this.homepageService.getSortPageByCache(this.sortWith,this.descendingWith,cache,this.listSize, offset, this.facets.join()).subscribe((data) => {
          data.data.resources.forEach((evt) => {
            this.bulletinlist.data.resources.push(evt);
          });
          this.lazyRequeat = false;
          this.viewRefresh = false;
          this.currentOffset = offset;
        });
      }*/
    }

  //Showing icon for image error.
    imageError(event, images){
      if(typeof($('body').find('img[custom="'+event+'"]').attr('index')) != 'undefined' &&  parseInt($('body').find('img[custom="'+event+'"]').attr('index')) > 0 ){
        var index:number = parseInt($('body').find('img[custom="'+event+'"]').attr('index'));
        if(typeof($('body').find('img[custom="'+event+'"]').attr('loaded')) != 'undefined')
        index--;
        this.imageLoad(event, images,index, true);
      } else {
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();          
      }
    }

  //loading best image
  imageLoad(event, images,index, fromError = false) {
    //console.log(event, 'ImageID');
    if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes' && !fromError) {
      return false;
    }
    if($('body').find('#'+event).length <= 0) {
       $('body').append('<img id="'+event+'" src="" style="display:none;">');
    }
    var $this = this;
    var imagesAll = this.searchService.sortedImage(images);
    $('#'+event).attr('src',imagesAll[index]);
    setTimeout(function(){
      var tempWidth = $('#'+event).width();
      //console.log(tempWidth, event, index);
      var temp = document.getElementById(event);
      if(tempWidth <= 1 && index > 0){
        $this.imageLoad(event,images,index-1, true);
        return false;
      }else if(tempWidth <= 1 && index == 0){
        $('body').find('img[custom="'+event+'"]').after('<span class="Placeholders '+$('body').find('img[custom="'+event+'"]').attr('name')+'"><i class="material-icons md-48">'+$('body').find('img[custom="'+event+'"]').attr('alt')+'</i></span>');
        $('body').find('img[custom="'+event+'"]').remove();
      }
    },500);
    if(typeof(imagesAll[index]) != 'undefined') {
      $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[index]);
      $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
      $('body').find('img[custom="'+event+'"]').attr('index',index);        
    }
  }
  /*
  imageLoad(event, images) {
    if($('body').find('img[custom="'+event+'"]').attr('loaded') == 'yes') {
      return false;
    }
     var sizes = ['xl','l','m','s','xs','xxs'];
     if($('body').find('#TempImg').length <= 0) {
       $('body').append('<img id="TempImg" src="" style="display:none;">');
     }
     var imagesAll = [];

     sizes.forEach((evt) => {
      images.forEach((img) => {
        if(img.size == evt){
          imagesAll.push(img.url);
        }
      });      
    });
     
    setTimeout(function() {
      if(typeof(imagesAll[0]) != 'undefined') {
        $('body').find('img[custom="'+event+'"]').attr('src',imagesAll[0]);
        $('body').find('img[custom="'+event+'"]').attr('loaded','yes');        
      } 
    },10);
  }
  */

  changeView(view){
    this.listView = view;
    this.cookieService.set( 'Popular_title_List_View', this.listView, 365,'/' );
  }

  deleteReview(id,event){
    if(confirm('Are you sure?')){
      var token =  localStorage.getItem('token');
      this.homepageService.deleteReview(id, token).subscribe((data) => {
          this.notifier.notify( 'success', 'Review has been deleted successfully');
          $(event.target).parents('.reviewCon').remove();
      },(err) => {
        this.notifier.notify( 'error', 'Something went wrong.Try again.');     
      });
    }
  }

  publishReview(reviewId,event){
    var token =  localStorage.getItem('token');
    var selector = $(event.target);
    if(event.target.nodeName == 'I'){
      var selector = $(event.target).parent();
    } 
    selector.removeClass('show').addClass('hide');    
    this.homepageService.publishReview(reviewId, token).subscribe((data) => {
      if(selector.hasClass('Publish')){
        this.notifier.notify( 'success', "Review has been published");
        selector.parent().find('.unPublish').removeClass('hide').addClass('show');
      } else {
        this.notifier.notify( 'success', "Review has been unpublished");
        selector.parent().find('.Publish').removeClass('hide').addClass('show');
      }
    },(err) => {
      this.notifier.notify( 'error', 'Something went wrong.Try again.');
      selector.removeClass('hide').addClass('show');
    });
  }

  getReviewDetail(reviewId){
    this.responseAPIstatus = false;
    this.homepageService.getReviewDetail(reviewId).subscribe((data:any) =>{
      this.resourcesDetail = data.data;
      if(this.resourcesDetail.reviewer == null){
        this.reviewerNameReadOnly = false;
      } else {
        this.reviewerNameReadOnly = true;
      }      
      this.homepageService.updateBannerText(this.resourcesDetail.title);
      this.selectedCategories = [];
      this.resourcesDetail.reviewCategories.forEach((cat) => {
        this.selectedCategories.push(cat.id);
      });
      this.responseAPIstatus = true;
    },(err) => {
      this.responseAPIstatus = true;    
    });
  }

   editReview(){
    var error= 0;
    var Id = $('#reviewid').val();
    this.editedReviewId = Id;
    var ratingStar = $('#reviewStarEdit').val();
    var reviewText = $('#reviewText').val();
    var reviewPublished:boolean = $('#ReviewPublished').is(':checked');
    if($.trim(reviewText.toString()) == ''){
      $('#reviewText').addClass('error');
      error++;
    }
    var reviewer = $('#reviewerName').val();
    if($.trim(reviewer.toString()) == ''){
      $('#reviewerName').addClass('error');
      error++;
    }
    if(error != 0){
      return false;
    }
    this.saveReviewStatus = true;
    var categories = [];
    $('.reviewCategory').find('input[type="checkbox"]:checked').each(function(){
      categories.push($(this).val());
    });
    var token =  localStorage.getItem('token');
    this.homepageService.editReview(Id, ratingStar, reviewText,reviewPublished, reviewer,categories,token).subscribe((data) => {
      this.notifier.notify( 'success', 'Review has been updated successfully');
      $('#closereviewAdd').trigger('click');
      if(this.reviewSearchForm){
        $('#reviewFormSubmit').trigger('click');
      }else{
        this.loadParamResource();
      }
      this.saveReviewStatus = false;
    },(err) => {
      this.notifier.notify( 'error', 'Something went wrong.Try again.');     
    });
  }

    
}
